export const getTenantBranding = (appearance = {}) => {
  return {
    ...appearance,
  };
};
